const WatchTutorial = () => (
  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3626 7.3209L3.87752 1.83052C2.54679 0.969465 0.791016 1.92466 0.791016 3.50966V14.4904C0.791016 16.0754 2.54679 17.0306 3.87752 16.1696L12.3626 10.6792C13.5806 9.89107 13.5806 8.10901 12.3626 7.3209Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)
export default WatchTutorial
